<script>
import ServicePrices from "@/modules/Tour/Admin/Item/Services/Item/ServicePrices.vue";

export default {
  components: {ServicePrices},
  props: {
    module: {
      type: Object,
    },
  },
  data() {
    return {
      servicePrices: this.module.servicePrices,
      activeName: 'serviceParameters',
    };
  },
};
</script>
<template>
  <FBody
    :module="module"
    @submit="$emit('submit')"
  >
    <el-tabs v-model="activeName">
      <el-tab-pane label="Услуга" name="serviceParameters">
    <RowSpan>
      <ColGroup label="Направление" :span="5">
        <FItem
          :module="module.getItem('country')"
        />
      </ColGroup>
      <ColGroup label="Направление" :span="5">
        <FItem
          :module="module.getItem('city')"
        />
      </ColGroup>
      <ColGroup label="Квота" :span="2">
        <FItem
          :module="module.getItem('quota')"
        />
      </ColGroup>
    </RowSpan>
    <RowSpan>
      <ColGroup label="Описание" :span="5">
        <FItem
          :module="module.getItem('transfer')"
        />
      </ColGroup>
      <ColGroup label="Описание" :span="5">

        <FItem
          :module="module.getItem('transport')"
        />
      </ColGroup>
      <ColGroup label="Сквозное" :span="2">
        <FItem
          :module="module.getItem('across')"
        />
      </ColGroup>
    </RowSpan>
    <RowSpan>
      <ColGroup span="6" label="Начало">
        <FItem
          :module="module.startDay"
          label="День"
        />
        <FItem
          :module="module.startTime"
          label="Время"
        />
      </ColGroup>
      <ColGroup span="6" label="Продолжительность">
        <FItem
          :module="module.durationDay"
          label="Дней"
        />
        <FItem
          :module="module.durationHour"
          label="Часов"
        />
      </ColGroup>
    </RowSpan>
      </el-tab-pane>
      <el-tab-pane label="Тарифы" name="tariffs">
        <ServicePrices :source-service-prices="servicePrices" :serviceClassId="module.service.value.value">
        </ServicePrices>
      </el-tab-pane>
    </el-tabs>
  </FBody>
</template>
<style lang="scss">

</style>
